import axios from "axios";

export default axios.create({
    baseURL: "http://superlog.online/api/",
    headers: {
        "Content-Type": "application/json"
    },
});